/* eslint-disable react/jsx-indent */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  AppBar, Toolbar, Grid, Typography, Box,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  ReactComponent as CareerWithConfidenceIcon,
} from '../admissions/components/icons/careerWithConfidence.svg';
import getBaseStyles from './baseStyles';

const styles = theme => ({
  ...getBaseStyles(theme),
});

const AdminWrapper = ({
  pageId,
  Icon,
  header,
  tagline,
  children,
}) => {
  const theme = useTheme();
  const classes = styles(theme);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <AppBar
        position="fixed"
        color="inherit"
        elevation={4}
      >
        <Toolbar sx={classes.headerContainer}>
          <Box sx={classes.logoWrapper}>
            <CareerWithConfidenceIcon style={classes.logoIcon} />
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="main" id={pageId} sx={classes.main}>
        <Box component="nav" sx={classes.topNav} aria-label="Admin page navigation" />
        <Grid container>
          <Grid
            size={12}
            elevation={2}
            sx={classes.pageWrapper}
          >
            <Grid container sx={{ ...classes.pgHeader, alignItems: 'center' }}>
              <Grid sx={classes.headerIcon}>
                {Icon && <Icon style={classes.icon} />}
              </Grid>
              <Grid sx={classes.headerHeading}>
                {header && (
                  <Typography variant="h1">
                    {header}
                  </Typography>
                )}
                {tagline && (
                  <Typography variant="h2" className="tagline">
                    {tagline}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Box component="nav" aria-label="Admin page navigation" sx={classes.pageNav} />
            {children()}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

AdminWrapper.defaultProps = {
  pageId: '',
  Icon: null,
  header: '',
  tagline: '',
};

AdminWrapper.propTypes = {
  pageId: PropTypes.string,
  Icon: PropTypes.objectOf(PropTypes.any),
  header: PropTypes.string,
  tagline: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.func]).isRequired,
};

export default AdminWrapper;
